import { render, staticRenderFns } from "./SalesLeadNotes.vue?vue&type=template&id=f0082140&scoped=true&"
import script from "./SalesLeadNotes.vue?vue&type=script&lang=js&"
export * from "./SalesLeadNotes.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadNotes.vue?vue&type=style&index=0&id=f0082140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0082140",
  null
  
)

export default component.exports